let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = Promise.all([load("bRMot"), load("aCh9P"), load("bxxT5"), load("4X3wS"), load("hSQJ5"), load("duj4r")]).then(() => parcelRequire('8ZHDV'));